<template lang="pug">
  div
    v-slide-y-reverse-transition(leave-absolute)
      v-skeleton-loader(
        v-if="init"
        type="list-item-two-line@5"
      )
    v-slide-y-reverse-transition(
      v-show="!init"
      group
      leave-absolute
    )
      v-card(
        v-for="(action, idx) in actions"
        :key="`${idx}${action.type}`"
        @click="resolve(action)"
        :style="`opacity: ${action.hasMessages || action.type === 2 ? '1' : '.8'}`"
      ).sdo-card.my-2

        v-card-text
          .d-flex.align-center
            div
              v-badge(left overlap :value="!!action.hasMessages" icon="mdi-message")
                v-row(no-gutters align="center").mb-3
                  tooltip-wrap(
                    text="Перейти в профиль"
                  )
                    v-btn(
                      fab
                      outlined
                      small
                      text
                      :to=`{
                        name: "StudentReview",
                        params: { id: action.user.id },
                      }`
                      target="_blank"
                      @click.stop
                    )
                      v-icon mdi-account-school
                  strong.ml-3 {{ action.user.full_name }}
              .caption(
                v-if="action.course"
                :class="{ 'font-weight-bold': !action.unit }"
              ) {{ action.course.title }}
              .caption(
                v-if="action.unit"
                :class="{ 'font-weight-bold': !action.lesson }"
              ) {{ action.unit.title }}
              .caption.font-weight-bold(v-if="action.lesson")
                span {{ action.lesson.title }}

              v-chip(
                v-if="action.type === TYPES.consultation"
                small
                color="secondary"
              ).mt-3.caption
                v-icon(left small) mdi-plus
                span новая консультация
              v-chip(
                v-else
                small
                color="warning"
              ).mt-3.caption
                v-icon(left small) mdi-plus
                span проверка задания
              v-chip(small outlined).mt-3.ml-2.caption
                v-icon(left small) mdi-clock
                span {{ action.date | dp('HH:mm') }}
              v-chip(small outlined).mt-3.ml-2.caption
                v-icon(left small) mdi-calendar
                span {{ action.date | dp:from-now }}
            .padding-left

        .sdo-side-element.accept-block
          .sdo-side-element--container
            div
              v-btn(
                fab
                text
                target="_blank"
                :to="toDetailTasks(action)"
                @click.stop
              )
                v-icon(color="secondary" large) mdi-text-box-outline
              .caption Задания
    div(v-if="!init" v-intersect="onIntersect")
</template>

<script>
import Chat from '@/models/list/Chat';

import { SUBJECT_TYPES, TYPES } from '../constants';

const ALIASES_SUBJECT = {
  [SUBJECT_TYPES.lesson]: 'lesson',
  [SUBJECT_TYPES.unit]: 'unit',
  [SUBJECT_TYPES.course]: 'course',
};

export default {
  props: {
    actions: { type: Array, default: () => ([]) },
    init: { type: Boolean, default: false },
    subjectType: { type: Number, default: SUBJECT_TYPES.course },
  },
  data: () => ({
    TYPES,

    loading: {
      actionClose: {},
    },
  }),
  methods: {
    onIntersect(entries) {
      if (entries[0].isIntersecting) {
        this.$emit('onIntersect');
      }
    },
    toDetailTasks(action) {
      const id = {
        course: action.course?.id,
        unit: action.unit?.id,
        lesson: action.lesson?.id,
      };
      return {
        name: 'ConsultationTasksDetail',
        params: { id: id[ALIASES_SUBJECT[this.subjectType]] },
        query: {
          user: action.user.id,
          type: ALIASES_SUBJECT[this.subjectType],
        },
      };
    },
    toCheckTask(action) {
      this.$router.push({
        name: 'TaskCheck',
        params: { id: action.task.id },
        query: { group: action.group?.id, user: action.user.id },
      });
    },
    async actionClose(action) {
      this.$set(this.loading.actionClose, action.id, true);
      await this.$api.chat.closeChat(action.chat_id);
      this.fetchActions();
      this.$set(this.loading.actionClose, action.id, false);
    },
    resolve(action) {
      if (action.type === TYPES.consultation) {
        action.hasMessages = false;
        return this.openChat(action);
      }
      return this.toCheckTask(action);
    },
    async openChat(action) {
      const room = await this.$api.chat
        .getRoomCourse(action.course?.id, { user_id: action.user.id });
      const chat = new Chat({
        id: action.chatId,
        tag: action.getTag(),
        replyTo: action.user,
        ...room.data.data,
      });
      chat.bindOnClose(this.fetchActions);
      this.$chat.set(chat, {
        opened: true,
        title: action.user.full_name,
        subtitle: action.getName(),
        consultationResponseMode: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.padding-left {
  padding-left: 100px;
}

.sdo-side-element {

  &.accept-block {
    right: 0;
  }
}
</style>
